export default "__VITE_ASSET__CwQp17sO__"